import {createRouter, createWebHistory, type RouteRecordRaw} from 'vue-router'
import LyFullPage from  '@dh/dh-for-vue';
import LySlideTopPage from "./components/layout/page/LySlideTopPage.vue";
import {devAllModModule, registerDevModule, registerPage} from '@dh/dh-for-vue';
import {GlobalShare} from  '@dh/dh-for-vue';


/**
 * 创建路由
 * @param params.base 基础路径
 * @param params.layoutBase 布局基础路径
 * @param params.fullBase 全屏基础路径
 * @param params.devModules 开发环境模块
 * @param params.prodModPath 生产环境模块路径 默认/vue/dist/:mod.js
 * @param params.pages 页面
 * @param params.vueRoutes 路由
 * @returns 路由
 */
export const createDhForRouter = (params: {
                                      base: string,
                                      layoutBase?: any,
                                      fullBase?: any,
                                      prodModPath?: string,
                                      devModPath?: string
                                      devModules?: Record<string, string>,
                                      devAllModules?:boolean,
                                      pages?: Record<string, Record<string, any>>,
                                      vueRoutes?: RouteRecordRaw[]
                                  }
) => {
    let {base, vueRoutes, devModules, pages, layoutBase, fullBase} = params;
    layoutBase = layoutBase || 'l';
    fullBase = fullBase || 'f';
    let routes: RouteRecordRaw[] = [
        {
            path: "/" + layoutBase + '/:moduleName/:pageName',
            component: LySlideTopPage,
        },
        {
            path: "/" + fullBase + '/:moduleName/:pageName',
            component: LyFullPage,
        }
    ];

    if (vueRoutes) {
        routes = routes.concat(vueRoutes);
    }
    if (devModules) {
        for (let key in devModules) {
            registerDevModule(key, devModules[key]);
        }
    }
    if(params.devAllModules){
        devAllModModule(params.devAllModules)
    }
    if (pages) {
        for (let moduleName in pages) {
            for (let pageKey in pages[moduleName]) {
                registerPage(moduleName, pageKey, pages[moduleName][pageKey]);
            }
        }
    }
    let router = createRouter({
        history: createWebHistory(base),
        routes
    })
    GlobalShare.router = router;
    if (params.prodModPath) {
        GlobalShare.prodModPath = params.prodModPath;
    }
    if(params.devModPath){
        GlobalShare.devModPath = params.devModPath;
    }
    return router;
}

